// extracted by mini-css-extract-plugin
export var hidden = "_54-1";
export var leftPanel = "_54-2";
export var readonlyInspector = "_54-3";
export var rightPanel = "_54-0";